import { render, staticRenderFns } from "./list-head-item.vue?vue&type=template&id=04fe3a87&scoped=true&"
import script from "./list-head-item.vue?vue&type=script&lang=js&"
export * from "./list-head-item.vue?vue&type=script&lang=js&"
import style0 from "./list-head-item.vue?vue&type=style&index=0&id=04fe3a87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fe3a87",
  null
  
)

export default component.exports